import React from "react";
import { Link } from "react-router-dom";
import { Crown, Lock } from "lucide-react";
import { Button } from "./ui/button";
import useSubscription from "../hooks/useSubscription";

export function ProLock({ feature = "this feature", className = "", testId = "pro-lock" }) {
  return (
    <div data-testid={testId} className={`border border-blue-500/40 bg-blue-500/5 p-5 text-center ${className}`}>
      <Lock className="w-6 h-6 text-blue-500 mx-auto mb-2" />
      <div className="font-display text-xl uppercase mb-1">Pro Feature</div>
      <div className="text-xs text-neutral-400 mb-4">{feature} is part of Pro.</div>
      <Link to="/pricing">
        <Button data-testid={`${testId}-upgrade`} className="bg-blue-500 hover:bg-blue-600 rounded-none uppercase tracking-wider font-display h-9">
          <Crown className="w-3 h-3 mr-2" /> Upgrade A$5/mo
        </Button>
      </Link>
    </div>
  );
}

export function TrialBanner() {
  const { sub } = useSubscription();
  if (!sub) return null;
  if (sub.is_scholarship) return null;
  if (!sub.is_pro) {
    return (
      <Link to="/pricing" data-testid="upgrade-banner" className="block border border-blue-500 bg-blue-500/10 p-3 mb-4 hover:bg-blue-500/20 transition-colors">
        <div className="flex items-center gap-3">
          <Crown className="w-5 h-5 text-blue-500" />
          <div className="flex-1 text-sm">
            <span className="font-display uppercase tracking-wide">Trial expired</span>
            <span className="text-neutral-300"> · Unlock Pro for A$5/month</span>
          </div>
          <span className="text-xs text-blue-500 uppercase tracking-widest">Upgrade →</span>
        </div>
      </Link>
    );
  }
  if (sub.in_trial && sub.days_left <= 7) {
    return (
      <Link to="/pricing" data-testid="trial-banner" className="block border border-blue-500/60 bg-blue-500/5 p-3 mb-4 hover:bg-blue-500/15 transition-colors">
        <div className="flex items-center gap-3">
          <Crown className="w-5 h-5 text-blue-500" />
          <div className="flex-1 text-sm">
            <span className="font-display uppercase tracking-wide">Trial · {sub.days_left} {sub.days_left === 1 ? "day" : "days"} left</span>
            <span className="text-neutral-400"> · Lock in Pro before it ends</span>
          </div>
          <span className="text-xs text-blue-500 uppercase tracking-widest">Upgrade →</span>
        </div>
      </Link>
    );
  }
  return null;
}
